import { StyleSheet } from 'react-native';
import React, { useEffect, useRef, useState } from 'react'
import { Column, Container, Grid, Row } from 'components/atoms/BootstrapGrid'
import ThemedTimePicker from 'components/atoms/ThemedTimePicker'
import HelperString from 'utils/helper-string'
import _ from 'lodash'
import CheckBox from 'theme/CheckBox'
import Text from "theme/Text";
import { useSelector } from 'react-redux'
import HelperTestID from 'utils/HelperTestID'
import { TESTID } from '_shared/config/testID'
import selectEmployeeWorkday from 'services/redux/data/selectors/selectEmployeeWorkday'
import { layoutStyles } from 'styles/layout'
import HelperDate from 'utils/helper-date'

const WorkdayInput = ({ day, onChange, testID = null }) => {
	
	const _employeeWorkday = useSelector( selectEmployeeWorkday( day ) )
	
	const formData = useRef( _employeeWorkday )
	
	const [ timeStart, setTimeStart ] = useState( formData.current.workday_start ?? '08:00' )
	const [ timeEnd, setTimeEnd ] = useState( formData.current.workday_end ?? '17:00' )
	const [ disabled, setDisabled ] = useState( _.isEmpty( formData.current ) )
	
	const dayWritten = HelperDate.date().day( day ).format('dddd')
	
	const onCheckbox = ( value ) => {
		setDisabled( !value )
	}
	
	const onChangeFormData = () => {
		formData.current = {
			workday_day: day,
			workday_start: disabled ? null : ( _.isEmpty( timeStart ) ? '00:00:00' : timeStart ),
			workday_end: disabled ? null :  ( _.isEmpty( timeEnd ) ? '00:00:00': timeEnd )
		}
		
		if( _.isFunction( onChange ) ) {
			onChange( formData.current )
		}
	}
	
	useEffect( () => {
		return onChangeFormData();
	}, [ timeStart, timeEnd, disabled ] )
	
	let timeStyle = staticStyles.timeStyleFlex1Width100
	
	let dayStyle = staticStyles.dayStyleFlexDirectionRowAlignItemsCenter
	
	let daySpan = { xs: 4, md: 4 }
	let timeSpan = 'auto'
	
	timeStyle = {
		...timeStyle,
		padding: 2,
		maxWidth: '100%'
	}
	
	daySpan.xs = 12
	dayStyle = {
		...dayStyle,
		paddingBottom: 4
	}
	
	timeSpan = 6

	
	return (
		<Grid testID={ testID }>
			<Container>
				<Row
					style={ staticStyles.rowMarginVertical4 }>
					
					<Column
						style={ dayStyle }
						span={ daySpan }>
						
						<CheckBox
							style={ staticStyles.checkBoxMarginRight4 }
							checked={ !disabled }
							onChange={ onCheckbox.bind( this ) }
							testID={ HelperTestID.generate( testID, 'checkbox' ) }
						/>
						
						<Text
							style={ layoutStyles.flexOne }>
							
							{ dayWritten }
						</Text>
					</Column>
					<If condition={ !disabled }>
						<Column
							span={ timeSpan }>
							
							<ThemedTimePicker
								key={ HelperString.hash('workday', 'select-time-start') }
								time={ timeStart }
								minuteInterval={ 15 }
								max={ timeEnd === '00:00:00' ? null : timeEnd }
								onSelect={ setTimeStart.bind( this ) }
								disabled={ disabled }
								style={ timeStyle }
								testID={ HelperTestID.generate( testID, TESTID.HOME.MORE.WORKDAYS.DAY_COMPONENT_TIME_START) }
							/>
						</Column>
						<Column
							span={ timeSpan }>
							
							<ThemedTimePicker
								key={ HelperString.hash('workday', 'select-time-end') }
								time={ timeEnd }
								minuteInterval={ 15 }
								min={ timeStart === '00:00:00' ? null : timeStart }
								onSelect={ setTimeEnd.bind( this ) }
								disabled={ timeStart === '00:00:00' ? true : disabled }
								style={ timeStyle }
								testID={ HelperTestID.generate( testID, TESTID.HOME.MORE.WORKDAYS.DAY_COMPONENT_TIME_END) }
							/>
						</Column>
					</If>
				</Row>
			</Container>
		</Grid>
	)
}

const staticStyles = StyleSheet.create({
	timeStyleFlex1Width100: {
		flex: 1,
		width: '100%',
	},
	dayStyleFlexDirectionRowAlignItemsCenter: {
		flexDirection: 'row',
		alignItems: 'center',
	},
	rowMarginVertical4: {
		marginVertical: 4,
	},
	checkBoxMarginRight4: {
		marginRight: 4,
	},
});

export default WorkdayInput
